

export class MaintenanceTypeOutputWithOutStatus implements IMaintenanceTypeOutputWithOutStatus {
    /** The auto-generated id of the maintenance master */
    maintenance_type_id!: number;
    /** The maintenance type name with 255 character limit */
    maintenance_type_name!: string;

    constructor(data?: IMaintenanceTypeOutputWithOutStatus) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.maintenance_type_id = _data["maintenance_type_id"];
            this.maintenance_type_name = _data["maintenance_type_name"];
        }
    }

    static fromJS(data: any): MaintenanceTypeOutputWithOutStatus {
        data = typeof data === 'object' ? data : {};
        let result = new MaintenanceTypeOutputWithOutStatus();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["maintenance_type_id"] = this.maintenance_type_id;
        data["maintenance_type_name"] = this.maintenance_type_name;
        return data; 
    }
}

export interface IMaintenanceTypeOutputWithOutStatus {
    /** The auto-generated id of the maintenance master */
    maintenance_type_id: number;
    /** The maintenance type name with 255 character limit */
    maintenance_type_name: string;
}

